/**
 * Internal dependencies
 */
import $ from 'jquery'
import { ajaxUrl } from 'bookwormgb'
import './common'
import Block from './block'
import renderFrontend from '../../util/render-frontend.js'

const getProps = el => ( {
	attributes: JSON.parse( el.dataset.attributes ),
	hasVisibilitySensor: true,
} )

renderFrontend(
	'.wp-block-bwgb-authors__content',
	Block,
	getProps
)

$( '.wp-block-bwgb-author' ).ready( function() {
	$( '.wp-block-bwgb-author' ).on( 'click', '.author-pagination a', function( event ) {
		event.preventDefault()

		const $this = $( this )
		const loader = $this.closest( '.wp-block-bwgb-author .wp-block-bwgb-authors__content' )
		const target = loader.data( 'attributes' )
		const page = $this.data( 'page' )
		const blockAttributes = { ...target, paged: page }

		$.ajax( {
			type: 'POST',
			url: ajaxUrl,
			data: {
				action: 'bookwormgb_authors_block_output_author',
				attributes: { ...blockAttributes }
			},
			dataType: 'json',
			beforeSend : function () {
				loader.find( '.author-content' ).addClass( 'author-pagination-ajax-loader' )
			},
			success: function( response ) {
				loader.html( response.output )
			},
		} )
	} )

	$( '.wp-block-bwgb-author' ).on( 'click', '.author-button', function( event ) {
		event.preventDefault()

		const $this = $( this )
		const loader = $this.closest( '.wp-block-bwgb-author .wp-block-bwgb-authors__content' )
		const target = loader.data( 'attributes' )
		const blockAttributes = { ...target, limit: target.limit += target.loadMoreCount }

		$.ajax( {
			type: 'POST',
			url: ajaxUrl,
			data: {
				action: 'bookwormgb_authors_block_output_author',
				attributes: { ...blockAttributes }
			},
			dataType: 'json',
			beforeSend : function () {
				loader.addClass('author-pagination-ajax-loader')
			},
			success: function( response ) {
				loader.removeClass('author-pagination-ajax-loader')

				loader.html( response.output )
			},
		} )
	} )
} )